const ATTRIBUTION_SCRIPT_ID = 'crate-attribution-embed-snippet';

const LOCAL_CORE_HOST = process.env.REACT_APP_CRATE_CORE_HOST || 'crate-core.com';

const DEFAULT_SNIPPET_URLS = {
  production: 'https://www.productioncrate.com/js/attribution.js',
  qa: 'https://staging.productioncrate.com/js/attribution.js',
  local: `http://${LOCAL_CORE_HOST}/js/attribution.js`,
};

function parseBoolean(value) {
  if (typeof value !== 'string') {
    return undefined;
  }

  const normalized = value.trim().toLowerCase();

  if (normalized === 'true') {
    return true;
  }

  if (normalized === 'false') {
    return false;
  }

  return undefined;
}

function isLocalHost(hostname) {
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '::1' ||
    hostname === LOCAL_CORE_HOST
  );
}

function resolveSnippetUrl(hostname) {
  const envOverride = process.env.REACT_APP_ATTRIBUTION_SNIPPET_URL?.trim();
  if (envOverride) {
    return envOverride;
  }

  if (isLocalHost(hostname)) {
    return DEFAULT_SNIPPET_URLS.local;
  }

  const isQaHost =
    hostname === 'staging.productioncrate.com' ||
    /(^|[.-])qa([.-]|$)/.test(hostname);

  if (isQaHost) {
    return DEFAULT_SNIPPET_URLS.qa;
  }

  return DEFAULT_SNIPPET_URLS.production;
}

function applyRuntimeConfigFromEnv() {
  const runtimeConfig = {};

  if (process.env.REACT_APP_ATTRIBUTION_API_BASE_URL) {
    runtimeConfig.apiBaseUrl = process.env.REACT_APP_ATTRIBUTION_API_BASE_URL;
  }

  if (process.env.REACT_APP_ATTRIBUTION_COOKIE_DOMAIN) {
    runtimeConfig.cookieDomain = process.env.REACT_APP_ATTRIBUTION_COOKIE_DOMAIN;
  }

  const enabledFromEnv = parseBoolean(process.env.REACT_APP_ATTRIBUTION_ENABLED);
  if (typeof enabledFromEnv === 'boolean') {
    runtimeConfig.enabled = enabledFromEnv;
  }

  if (Object.keys(runtimeConfig).length === 0) {
    return;
  }

  window.__CRATE_ATTRIBUTION_CONFIG__ = {
    ...(window.__CRATE_ATTRIBUTION_CONFIG__ || {}),
    ...runtimeConfig,
  };
}

export function injectAttributionSnippet() {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  if (document.getElementById(ATTRIBUTION_SCRIPT_ID)) {
    return;
  }

  applyRuntimeConfigFromEnv();

  const scriptUrl = resolveSnippetUrl(window.location.hostname);
  if (!scriptUrl) {
    return;
  }

  const scriptElement = document.createElement('script');
  scriptElement.id = ATTRIBUTION_SCRIPT_ID;
  scriptElement.src = scriptUrl;
  scriptElement.async = true;
  document.head.appendChild(scriptElement);
}
